import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, ValidationErrors, Validators} from "@angular/forms";
import {phoneValidator, ValidateEmail, zipValidator} from "../validators/form-validator";
import {stateValidator} from "../validators/state.validator";
import {AppModule} from "../../app.module";
import {GrievanceRequest} from "../../models/grievance.request";
import {PlansService} from "../../services/plans.service";

@Component({
  selector: 'app-grievance-form',
  templateUrl: './grievance-form.component.html',
  styleUrl: './grievance-form.component.scss'
})
export class GrievanceFormComponent implements OnInit, OnDestroy, AfterViewInit  {
  gForm:FormGroup = new FormGroup(
    {
      firstName: new FormControl('',[Validators.required]),
      lastName: new FormControl('',[Validators.required]),
      otherName: new FormControl(''),
      address1: new FormControl('', [Validators.required,Validators.minLength(4)]),
      city: new FormControl('', [Validators.required]),
      state: new FormControl('', [stateValidator(),Validators.required, Validators.minLength(2),Validators.maxLength(2)]),
      zipCode: new FormControl('', [zipValidator,Validators.required]),
      email: new FormControl('', [Validators.required, ValidateEmail]),
      phoneNumber: new FormControl('', [Validators.required,Validators.minLength(10),Validators.maxLength(13),phoneValidator]),
      officeName: new FormControl('',[Validators.required]),
      officeAddress1: new FormControl('', [Validators.required,Validators.minLength(4)]),
      officeCity: new FormControl('', [Validators.required]),
      officeState: new FormControl('', [stateValidator(),Validators.required, Validators.minLength(2),Validators.maxLength(2)]),
      officeZipCode: new FormControl('', [zipValidator,Validators.required]),
      officePhoneNumber: new FormControl('', [Validators.required,Validators.minLength(10),Validators.maxLength(13),phoneValidator]),
      officeEmail: new FormControl('', [Validators.required, ValidateEmail]),
      message: new FormControl('',[Validators.required]),
    }
  )
  showSuccessMessage:boolean = false;
  constructor(private service:PlansService) {
  }

  ngOnInit(): void {

  }

  ngOnDestroy(): void {

  }

  ngAfterViewInit(){
    window.scroll(0,-window.scrollY);
  }

  sendForm(){
    //builds the request
    let request:GrievanceRequest = {
      memberInfo: {
        firstName: this.gForm.get('firstName')?.value,
        lastName: this.gForm.get('lastName')?.value,
        email: this.gForm.get('email')?.value,
        phone: this.gForm.get('phoneNumber')?.value,
        mainSubscriber: this.gForm.get('otherName')?.value,
        address:{
          streetAddress:this.gForm.get('address')?.value,
          city:this.gForm.get('city')?.value,
          state:this.gForm.get('state')?.value,
          zip:this.gForm.get('zipCode')?.value,
        }
      },
      dentistInfo:{
        name:this.gForm.get('officeName')?.value,
        phone:this.gForm.get('officePhoneNumber')?.value,
        address:{
          streetAddress:this.gForm.get('officeAddress')?.value,
          city:this.gForm.get('officeCity')?.value,
          state:this.gForm.get('officeState')?.value,
          zip:this.gForm.get('officeZipCode')?.value,
        },
      },
      grievanceDescription:this.gForm.get('message')?.value,
      brand:'sgdp'
    }
    this.service.sendGrievanceForm(request).subscribe(
      (result) => {
        this.showSuccessMessage = true;
        window.scroll(0,0);
      }, (error) => {
        console.log(error);
      }
    )
  }

  translateError(error:string){
    let returnError:string = '';
    switch(error){
      case 'minlength':
        returnError = 'Field is not long enough';
        break;
      case 'invalidPhone':
        returnError = 'Phone Number is not valid';
        break;
      case 'invalidEmail':
        returnError = 'Email is not valid';
        break;
      case 'invalidDate':
        returnError = 'The Date provided is invalid';
        break;
      case 'notAnAdult':
        returnError = 'The responsible party cannot be a minor';
        break;
      case 'incorrectState':
        returnError = 'State is not a valid State';
        break;
      case 'invalidZip':
        returnError = 'ZipCode is not valid';
        break;
      case 'required':
        returnError = 'Field is required';
        break;
      default:
        returnError = 'Field is not valid';
        break;
    }
    return returnError;
  }
}
